import Feature from 'components/framework/models/Feature';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class FeatureFields extends RecordFields {
  static modelClass = Feature;
}

registerRecordFieldsClasses({ FeatureFields });
